import { useEffect, useRef } from 'react';
import { LeadDelCotizador, registrarVendedorDelLead } from './registrarVendedor';

/**
 * Enganche de venta presencial en la pantalla de precios: cuando hay lead, le
 * avisa al BFF qué asesor y en qué sucursal lo trajo. Espera a que cargue la
 * configuración (hasta entonces no se sabe si el lead es del monolito o del
 * BFF) y manda una sola vez por lead. El landingUrl y la foto del vendedor se
 * leen del último render, sin disparar un envío nuevo cuando cambian.
 */
export const useRegistroVendedor = (
  lead: LeadDelCotizador,
  origen: string,
  viaBff: boolean,
  configCargando: boolean
): void => {
  const ultimoLead = useRef(lead);
  ultimoLead.current = lead;
  const enviado = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (configCargando || !lead.contactoId) return;
    const clave = String(lead.contactoId);
    if (enviado.current === clave) return;
    enviado.current = clave;
    registrarVendedorDelLead(ultimoLead.current, origen, viaBff);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lead.contactoId, viaBff, configCargando]);
};
